<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='经典内容'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-button type="primary" @click="showAddDialog">添加内容</el-button>&nbsp;
          <el-input placeholder="请输入标题" style="width: 350px;" v-model="param.keywords" clearable @clear="search">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
      </el-row>
    </el-card>
   <el-table :data="contentList" stripe border :cell-style="{ textAlign: 'center' }">
      <el-table-column prop="id" label="ID" align="center" width="60px"></el-table-column>
      <el-table-column prop="pic" label="图片" align="center">
        <template slot-scope="scope">
          <el-image v-if="scope.row.pic!=''" :src="scope.row.pic+'?imageView2/2/w/75'"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="标题" align="center" width="270px">
        <template slot-scope="scope">
          <a :href="scope.row.url" target="_blank">{{scope.row.title}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="category_title" label="分类" align="center"></el-table-column>
      <el-table-column prop="character_title" label="特色栏目" align="center"></el-table-column>
      <el-table-column label="作者" align="center">
        <template slot-scope="scope">
          {{scope.row.author_id | getAuthorName(authorList)}}
        </template>
      </el-table-column>
      <el-table-column prop="hits" label="点击量" align="center" width="80px"></el-table-column>
      <el-table-column label="添加时间" align="center" width="200px">
        <template slot-scope="scope">
          {{scope.row.update_time | dateTimeFormat}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100px">
        <template slot-scope="scope">
          <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
   <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="param.page"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="param.count"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <content-classical-add
      :visible="addDialogAvaible"
      @close="closeAddDialog">
    </content-classical-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import ContentClassicalAdd from './ContentClassicalAdd.vue'
export default {
  name: 'content_classical_list',
  components: {
    'bread-crumb': BreadCrumb,
    'content-classical-add': ContentClassicalAdd
  },
  created () {
    this.getAuthorList()
    this.getContentList()
  },
  data () {
    return {
      authorList: [],
      contentList: [],
      currentId: 0,
      total: 0,
      pageTotal: 1,
      param: {
        keywords: '',
        type: [20],
        classical_list: 1,
        page: 1,
        count: 10
      },
      addDialogAvaible: false
    }
  },
  filters: {
    getAuthorName (id, authorList) {
      for (var i = 0; i < authorList.length; i++) {
        if (authorList[i].id === id) {
          return authorList[i].title
        }
      }
      return ''
    }
  },
  methods: {
    async getAuthorList () {
      const res = await this.$http.get('/admin/author/select_list')
      if (res.code === 0) {
        this.authorList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getContentList () {
      const res = await this.$http.get('/admin/content/list', this.param)
      if (res.code === 0) {
        this.contentList = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
        this.canComment = res.data.can_comment
      } else {
        this.$message.error(res.msg)
      }
    },
    search () {
      this.param.page = 1
      this.getContentList()
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getContentList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getContentList()
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.getContentList()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/content/delete_from_classical', {
          id: id
        })
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getContentList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.list_img {
  width: 50px;
}
</style>
